import { AxiosInstance } from 'axios';

import { IAuthenticationToken } from '@hsp/utilities';

import { Uri } from 'constants/uri';

export const refreshToken = (instance: AxiosInstance, token: IAuthenticationToken): Promise<IAuthenticationToken> => {
  return instance?.request({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    data: token,
    method: 'POST',
    url: Uri.Authentication.Token.refresh,
    withCredentials: true,
  });
};
